import React from 'react';
import { createRoot } from 'react-dom/client';

import { FAQAccordion } from '@shared/FAQAccordion';

const stripHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
};

const injectFaqSchema = (questions) => {
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: questions.map((q) => ({
      '@type': 'Question',
      name: q.question,
      acceptedAnswer: { '@type': 'Answer', text: stripHtml(q.answer) },
    })),
  });
  document.head.appendChild(script);
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('pre[data-faq]').forEach((script, nodeIndex) => {
    let items;
    try {
      items = JSON.parse(script.textContent);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('[FAQPage] Invalid JSON in data-faq block', e);
      return;
    }

    if (!Array.isArray(items)) {
      // eslint-disable-next-line no-console
      console.error('[FAQPage] data-faq JSON must be an array');
      return;
    }

    const title = script.getAttribute('data-faq-title') || 'Questions fréquentes';

    const faqList = {
      title,
      sections: [
        {
          questions: items.map((item, i) => ({
            id: `faq-page-${nodeIndex}-${i}`,
            question: item.question,
            answer: item.answer,
          })),
        },
      ],
    };

    const container = document.createElement('div');
    script.parentNode.insertBefore(container, script.nextSibling);
    script.remove();

    injectFaqSchema(faqList.sections[0].questions);

    const root = createRoot(container);
    root.render(<FAQAccordion faqList={faqList} withSchema={false} />);
  });
});
